<div class="alert alert-info" *ngIf="hasInstructions()">
	<span [innerHTML]="getInstructions()"></span>
</div>

<div>
  <h1 role="heading" class="screen-reader-only" aria-label="F.T.E.">F.T.E.</h1>
</div>

<div *ngIf="!fte">
	Loading...
</div>
<div *ngIf="!!fte">
	<div class="row">
		<div class="col-md-5" *ngIf="!!fte.county.length">
			<div class="card">
				<div class="card-header">
					<button class="btn btn-sm btn-link float-right" (click)="editCounty()">
						<i class="fa fa-fw fa-pencil"></i>
						Edit
					</button>
					County FTE
				</div>
				<table class="table table-bordered table-flush">
					<thead>
						<tr>
							<th>County</th>
							<th class="text-center">Yearly&nbsp;FTE</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let a of fte.county">
							<td>
								{{a.county.name}}

								<i class="fa fa-fw fa-home"
									[hidden]="!a.isHeadquarters"
									title="Headquarters"></i>

								<i class="fa fa-fw fa-user" 
									[hidden]="!a.isDirector"
									title="County Director"></i>
							</td>
							<td class="text-center"> {{formattedFte(a.fte)}} </td>
						</tr>
						<tr>
							<td colspan="2">
								<academic-report-submission 
									[submissionType]="SubmissionType.CountyFTE"
									[disabled]="countyFteSum() < .999"
									btnClass="btn-block">
								</academic-report-submission>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	
		<div class="col-md-7">
			<div [ngSwitch]="!!fte.conditionChange.length">
				<div *ngSwitchCase="false" class="card px-5">
					<empty-state
						imgSrc="/assets/empty/target.png"
						[title]=title
						description="">
							<button class="btn btn-primary btn-sm"
								(click)="editConditionChange()">
								+ Add Program FTE
							</button>
					</empty-state>
				</div>
				<div *ngSwitchCase="true" class="card">
					<div class="card-header">
						<button class="btn btn-sm btn-link float-right" (click)="editConditionChange()">
							<i class="fa fa-fw fa-pencil"></i>
							Edit
						</button>
						Program FTE
					</div>
					<div class="card-body">
						<div class="text-sm text-muted">
							Programs reflect the programmatic topics used to organize UC ANR’s Program Team structure. 
						</div>
					</div>
					<table class="table table-bordered table-flush-except-top">
						<thead>
							<tr>
								<th>Program</th>
								<th class="text-center">Yearly&nbsp;FTE</th>
							</tr>
						</thead>
						<tbody class="text-sm">
							<ng-container *ngFor="let f of fte?.conditionChange">
								<tr>
									<td>
										{{f.programArea.name}} <div *ngIf="f.programArea.disabled" class="text-xs">(No longer active)</div>
									</td>
									<td class="text-center">{{formattedFte(f.fte)}}</td>
								</tr>
							</ng-container>
							<tr>
								<td colspan="3">
									<academic-report-submission 
										[submissionType]="SubmissionType.ConditionChangeFTE"
										btnClass="btn-block">
									</academic-report-submission>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

		</div>
	</div>

	<div [ngSwitch]="!!fte.projects.length">
		<span class="h5 my-4" style="display:inline-block">Planning multi-state effort for the future</span>
		<div *ngSwitchCase="false" class="card">
			<empty-state
				imgSrc="/assets/empty/states.png"
				title="You haven't started any projects"
				description="Would you like to start one now?">
					<button class="btn btn-primary btn-sm"
						(click)="newProject()">
						+ Add a Project
					</button>
			</empty-state>
		</div>
		<div class="card" *ngSwitchCase="true">
			<div class="card-header">
				<button class="btn btn-sm btn-secondary float-right" (click)="newProject()">
					+ Add a Project
				</button>
				Multi-state Effort
			</div>
			<div class="card-body text-sm">
				Multi-state effort involves Cooperative Extension academics from multiple states.
				<br>
				The information you provide here about any multi-state collaborations will assist in maintaining ANR&apos;s federal funding.
			</div>
			<table class="table table-bordered table-flush" style="border-top:1px solid #ddd;">
				<thead>
					<tr>
						<th rowspan="2">Project</th>
						<th colspan="2" class="text-muted text-sm text-center">Collaborators</th>
						<th rowspan="2" style="width:125px;">Multi-state?</th>
						<th rowspan="2" style="width:85px;" class="text-center" [matTooltip]="aesTooltipText">
							AES
							<i class="fa fa-fw fa-info-circle text-muted text-sm"></i>
						</th>
						<th rowspan="2" class="text-center">Multi-state&nbsp;FTE</th>
						<th rowspan="2" style="width:130px;">Start&nbsp;Date</th>
						<th rowspan="2" style="width:130px;">End&nbsp;Date</th>
						<th rowspan="2" class="text-center">Edit</th>
					</tr>
					<tr>
						<th class="text-center" style="width:70px">ANR</th>
						<th class="text-center" style="width:100px;">Non-ANR</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let p of fte.projects">
						<td>{{p.name}}</td>
						<td class="text-center" [matTooltip]="p.ANRCollaboratorsTooltip">{{p.ANRCollaborators.length}}</td>
						<td class="text-center" [matTooltip]="p.NonANRCollaboratorsTooltip">{{p.NonANRCollaborators.length}}</td>
						<ng-container [ngSwitch]="p.multiStateInfo.hasValue()">
							<ng-container *ngSwitchCase="true">
								<td class="text-center">Yes</td>
								<td>{{p.multiStateInfo.value.aes ? 'Yes' : 'No'}}</td>
								<td class="text-center">{{formattedFte(p.multiStateInfo.value.fte)}}</td>
								<td>{{p.multiStateInfo.value.startDate | date}}</td>
								<td>{{p.multiStateInfo.value.endDate | date}}</td>
							</ng-container>
							<ng-container *ngSwitchCase="false">
								<td class="text-center">No</td>
								<td class="table-muted text-muted">N/A</td>
								<td class="table-muted text-muted">N/A</td>
								<td class="table-muted text-muted">N/A</td>
								<td class="table-muted text-muted">N/A</td>
							</ng-container>
						</ng-container>
						<td>
							<button class="btn btn-sm btn-link" 
							(click)="editProject(p)">
								Edit
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>